import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getEditCinemaRuleCustom as _getEditCinemaRuleCustom, getEditCinemaRuleCinema as _getEditCinemaRuleCinema, getEditCakestoreRuleCustom as _getEditCakestoreRuleCustom, getEditCakehomeRuleCustom as _getEditCakehomeRuleCustom, getEditFlowerRuleCustom as _getEditFlowerRuleCustom, getEditTicketRuleCustom as _getEditTicketRuleCustom } from '@/api/goodsCenter';
export default {
  name: 'priceAdjustmentDialog',
  data: function data() {
    return {
      rangeDialog: false,
      searchForm: {
        company_name: '',
        standard_id: '',
        cinema_name: '',
        page: 1,
        pagesize: 5
      },
      type: '',
      // cinema 影院 custom客户
      moduleType: '',
      // cakestore蛋糕到店  cakehome蛋糕到家  没传则是电影调价规则
      rule_id: '',
      totalCount: null,
      list: []
    };
  },
  methods: {
    getList: function getList() {
      this.rangeDialog = true;
      this.getData();
    },
    searchData: function searchData() {
      this.searchForm.page = 1;
      this.getData();
    },
    getData: function getData() {
      if (this.moduleType == 'cakestore') {
        this.getEditCakestoreRuleCustom();
      } else if (this.moduleType == 'cakehome') {
        this.getEditCakehomeRuleCustom();
      } else if (this.moduleType == 'flower') {
        this.getEditFlowerRuleCustom();
      } else if (this.moduleType == 'cinema') {
        this.type == 'cinema' ? this.getEditCinemaRuleCinema() : this.getEditCinemaRuleCustom();
      } else if (this.moduleType == 'ticket') {
        this.getEditTicketRuleCustom();
      }
    },
    getEditCinemaRuleCustom: function getEditCinemaRuleCustom() {
      var _this = this;
      _getEditCinemaRuleCustom(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        rule_id: this.rule_id
      })).then(function (res) {
        _this.list = res.data.data.data;
        _this.totalCount = res.data.data.totalCount;
      });
    },
    getEditCinemaRuleCinema: function getEditCinemaRuleCinema() {
      var _this2 = this;
      _getEditCinemaRuleCinema(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        rule_id: this.rule_id
      })).then(function (res) {
        _this2.list = res.data.data.data;
        _this2.totalCount = res.data.data.totalCount;
      });
    },
    getEditCakestoreRuleCustom: function getEditCakestoreRuleCustom() {
      var _this3 = this;
      _getEditCakestoreRuleCustom(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        rule_id: this.rule_id
      })).then(function (res) {
        _this3.list = res.data.data.data;
        _this3.totalCount = res.data.data.totalCount;
      });
    },
    getEditTicketRuleCustom: function getEditTicketRuleCustom() {
      var _this4 = this;
      _getEditTicketRuleCustom(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        rule_id: this.rule_id
      })).then(function (res) {
        _this4.list = res.data.data.data;
        _this4.totalCount = res.data.data.totalCount;
      });
    },
    getEditFlowerRuleCustom: function getEditFlowerRuleCustom() {
      var _this5 = this;
      _getEditFlowerRuleCustom(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        rule_id: this.rule_id
      })).then(function (res) {
        _this5.list = res.data.data.data;
        _this5.totalCount = res.data.data.totalCount;
      });
    },
    getEditCakehomeRuleCustom: function getEditCakehomeRuleCustom() {
      var _this6 = this;
      _getEditCakehomeRuleCustom(_objectSpread(_objectSpread({}, this.searchForm), {}, {
        rule_id: this.rule_id
      })).then(function (res) {
        _this6.list = res.data.data.data;
        _this6.totalCount = res.data.data.totalCount;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.pagesize = val;
      this.getData();
    },
    onChange: function onChange(val) {
      this.searchForm.page = val;
      this.getData();
    },
    closeDialog: function closeDialog() {
      this.searchForm = {
        id: '',
        company_name: '',
        standard_id: '',
        cinema_name: '',
        page: 1,
        pagesize: 5
      };
    }
  }
};